import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { GET_MOTIVOS_AJUSTE } from "../../../data/graphQL/queries/PreLiquidacion/getMotivosAjuste";
import { GET_AJUSTE_BY_DETALLE } from "../../../data/graphQL/queries/PreLiquidacion/getAjusteByDetalle";
import { CREATE_AJUSTE_LIQUIDACION } from "../../../data/graphQL/mutations/AjusteLiquidacion/createAjusteLiquidacion";
import { UPDATE_AJUSTE_LIQUIDACION } from "../../../data/graphQL/mutations/AjusteLiquidacion/updateAjusteLiquidacion";
import { DELETE_AJUSTE_LIQUIDACION } from "../../../data/graphQL/mutations/AjusteLiquidacion/deleteAjusteLiquidacion";

export const useAjusteLiquidacion = ({ onSuccess }) => {
    const [motivos, setMotivos] = useState([]);
    const [ajusteExistente, setAjusteExistente] = useState(null);

    // ── Motivos (carga única) ────────────────────────────────────────────────

    const { data: motivosData } = useQuery(GET_MOTIVOS_AJUSTE);

    useEffect(() => {
        if (!motivosData?.motivosAjuste) return;
        setMotivos(
            motivosData.motivosAjuste.map(m => ({
                id: m.idMotivoAjuste,
                displayName: m.descripcion
            }))
        );
    }, [motivosData]);

    // ── Get ajuste por detalle (modo edición) ────────────────────────────────

    const [getAjuste, { loading: loadingAjuste }] = useLazyQuery(GET_AJUSTE_BY_DETALLE, {
        fetchPolicy: 'no-cache',
    });

    const fetchAjuste = (idLiquidacionProfesionalDetalle) => {
        setAjusteExistente(null);
        if (!idLiquidacionProfesionalDetalle) return;
        getAjuste({ variables: { idLiquidacionProfesionalDetalle } })
            .then((data) => setAjusteExistente(data?.data?.ajusteByDetalle ?? null));
    };

    const limpiarAjuste = () => setAjusteExistente(null);

    // ── Mutations ────────────────────────────────────────────────────────────

    const [createAjuste, { loading: creating }] = useMutation(CREATE_AJUSTE_LIQUIDACION);
    const [updateAjuste, { loading: updating }] = useMutation(UPDATE_AJUSTE_LIQUIDACION);
    const [deleteAjuste, { loading: deleting }] = useMutation(DELETE_AJUSTE_LIQUIDACION);

    const guardarAjuste = async (input) => {
        try {
            const esEdicion = !!ajusteExistente;
            const mutation = esEdicion ? updateAjuste : createAjuste;

            await mutation({ variables: { input } });

            toast.success(esEdicion ? 'Ajuste actualizado correctamente' : 'Ajuste creado correctamente');
            onSuccess?.();
            return true;
        } catch (e) {
            toast.error('Ocurrió un error al guardar el ajuste');
            console.error(e);
            return false;
        }
    };

    const eliminarAjuste = async (idLiquidacionProfesionalDetalle) => {
        try {
            await deleteAjuste({ variables: { idLiquidacionProfesionalDetalle } });
            toast.success('Ajuste eliminado correctamente');
            onSuccess?.();
            return true;
        } catch (e) {
            toast.error('Ocurrió un error al eliminar el ajuste');
            console.error(e);
            return false;
        }
    };

    return {
        motivos,
        ajusteExistente,
        loadingAjuste,
        loadingMutation: creating || updating || deleting,
        fetchAjuste,
        limpiarAjuste,
        guardarAjuste,
        eliminarAjuste
    };
};